import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, typography }) => ({
  root: ({ size }) => ({
    position: 'relative',
    display: 'inline-flex',
    width: size,
    height: size
  }),
  backgroundCircle: {
    color: palette.grey[200],
    position: 'absolute',
    left: 0,
    top: 0,
    '& .MuiCircularProgress-circle': {
      strokeLinecap: 'round'
    }
  },
  progressCircle: {
    position: 'absolute',
    left: 0,
    top: 0,
    '& .MuiCircularProgress-circle': {
      strokeLinecap: 'round'
    }
  },
  scoreContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  scoreText: {
    ...typography.heading.h2,
    fontWeight: typography.weight.bold,
    color: palette.text.primary,
    fontSize: '3rem'
  }
}))
